import { Text } from "@mantine/core"
import { createColumnHelper } from "@tanstack/react-table"
import { ActionIcon } from "@tfg/ui"
import { useMemo } from "react"

import { FindAllActivitiesResponseDto } from "~/gen/api"
import { useDeleteActivityMutation } from "~/pages/Admin/Ingestion/Activities/hooks/useDeleteActivityMutation"

const columnHelper = createColumnHelper<FindAllActivitiesResponseDto>()

export const useColumns = (activities: FindAllActivitiesResponseDto[]) => {
  const { mutate: deleteActivity } = useDeleteActivityMutation()

  return useMemo(
    () => [
      columnHelper.accessor("id", {
        header: "ID",
        cell: ({ getValue }) => <Text>{getValue()}</Text>,
      }),
      columnHelper.accessor("name", {
        header: "Name",
        cell: ({ getValue }) => <Text>{getValue()}</Text>,
      }),
      columnHelper.accessor((row) => row.id, {
        header: () => null,
        id: "delete",
        enableSorting: false,
        cell: ({ row }) => (
          <ActionIcon
            type="delete"
            onClick={() => deleteActivity(row.original.id)}
          />
        ),
      }),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activities]
  )
}
